import { render, staticRenderFns } from "./ObjectPage.vue?vue&type=template&id=3fd613d5&scoped=true&"
import script from "./ObjectPage.vue?vue&type=script&lang=js&"
export * from "./ObjectPage.vue?vue&type=script&lang=js&"
import style0 from "./ObjectPage.vue?vue&type=style&index=0&id=3fd613d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd613d5",
  null
  
)

export default component.exports